export const toClassName = (str: string) => str.toLowerCase().replace(/\s+/g, '-');
